import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const baseText = 'What are the pros and cons of'

const prosAndConsTitle: Record<CreditCardProductCategory, string> = {
    ['BalanceTransfer']: `${baseText} balance transfer credit cards?`,
    ['BestCards']: `${baseText} credit cards?`,
    ['Cashback']: `${baseText} cashback credit cards?`,
    ['Combined']: `${baseText} balance transfer and purchase credit cards?`,
    ['PoorCredit']: `${baseText} credit cards for bad credit?`,
    ['Purchase']: `${baseText} 0% purchase credit cards?`,
    ['Rewards']: `${baseText} rewards credit cards?`,
    ['Travel']: `${baseText} travel credit cards?`,
}

export default prosAndConsTitle
